var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "avue-sidebar" },
    [
      _c(
        "el-scrollbar",
        { staticStyle: { height: "100%" } },
        [
          _vm.menu
            ? _c(
                "el-menu",
                {
                  attrs: {
                    id: "my-menu",
                    "default-active": _vm.nowTagValue,
                    "show-timeout": 200,
                    collapse: _vm.keyCollapse,
                    "unique-opened": "",
                    mode: "vertical",
                  },
                },
                [
                  _c("sidebar-item", {
                    attrs: {
                      menu: _vm.menu,
                      screen: _vm.screen,
                      props: _vm.website.menu.props,
                      collapse: _vm.keyCollapse,
                      first: "",
                      "popper-class": "sidebar-popper-class",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.showCollapse
            ? _c(
                "div",
                {
                  staticClass: "menu-func",
                  class: [{ "avue-breadcrumb": _vm.isCollapse }],
                },
                [
                  _vm.isCollapse
                    ? _c("img", {
                        staticClass: "icon-menu",
                        attrs: {
                          src: require("../../../../public/images/icon_menu_retract.png"),
                          alt: "",
                        },
                        on: { click: _vm.setCollapse },
                      })
                    : _c("img", {
                        staticClass: "icon-menu icon-menu-avue-breadcrumb",
                        attrs: {
                          src: require("../../../../public/images/icon_menu_open.png"),
                          alt: "",
                        },
                        on: { click: _vm.setCollapse },
                      }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isCollapse,
                          expression: "!isCollapse",
                        },
                      ],
                    },
                    [_vm._v("收起导航")]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }